/*
 * @forgerock/ping-javascript-sdk
 *
 * recaptcha-callback.ts
 *
 * Copyright (c) 2020 - 2025 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { BaseCallback } from './base-callback.js';
/**
 * Represents a callback used to integrate reCAPTCHA.
 */
export class ReCaptchaEnterpriseCallback extends BaseCallback {
    payload;
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Gets the reCAPTCHA site key.
     */
    getSiteKey() {
        return this.getOutputByName('recaptchaSiteKey', '');
    }
    /**
     * Get the api url
     */
    getApiUrl() {
        return this.getOutputByName('captchaApiUri', '');
    }
    /**
     * Get the class name
     */
    getElementClass() {
        return this.getOutputByName('captchaDivClass', '');
    }
    /**
     * Sets the reCAPTCHA result.
     */
    setResult(result) {
        this.setInputValue(result);
    }
    /**
     * Set client client error
     */
    setClientError(error) {
        this.setInputValue(error, 'IDToken1clientError');
    }
    /**
     * Set the recaptcha payload
     */
    setPayload(payload) {
        this.setInputValue(payload, 'IDToken1payload');
    }
    /**
     * Set the recaptcha action
     */
    setAction(action) {
        this.setInputValue(action, 'IDToken1action');
    }
}
